/* eslint-disable no-nested-ternary */
import React, { useEffect, useContext, useState } from 'react';
import { Backdrop } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import LinearProgress from '@material-ui/core/LinearProgress';
import { emptyText } from '@mummssoftware/utils/constants';
import { GlobalContext } from '@mummssoftware/global-context/GlobalContext';
import {
  OrdersGlobalContext,
  SET_NOTE_TEXT,
} from '@mummssoftware/global-context/OrdersGlobalContext';
import { BorderNote } from './Note';
import SubmitNote from './SubmitNote';
import TagNote from '../TagNote';
import {
  TextAreaGroup,
  TextAreaWrapper,
  BorderGroup,
} from '../../components/layout/WrapperDiv';
import { DischargeMedsModal } from '../MenuContent/DischargeMedsModal';
import { RcopiaModal } from '../MenuContent/RcopiaModal';
import OrderStatement from '../Statements/OrderStatement';
import { Context } from '../../context';
import { ProgressNotesContext } from '../Context/ProgressNotesContext';
import { SET_NOTE_STARTED } from '../Context/constants';
import { useStyles } from '../style/style';
import defaults from '../../translations/en.json';

const NoteInput = () => {
  const {
    smallWidget,
    currentUser,
    rcopiaRes,
    saveNoteText,
    admitErrorCount,
  } = useContext(Context);
  const { appVisit, attemptedVisitNote } = useContext(GlobalContext);

  const { orderCreated, noteStarted, emptyNote, dispatch } = useContext(
    ProgressNotesContext,
  );
  const { orderType, savedNote, dispatchOrders } = useContext(
    OrdersGlobalContext,
  );

  const [noteInputText, setNoteInputText] = useState<string>(
    attemptedVisitNote || emptyText,
  );

  const classes = useStyles();
  const isRcopiaOpen = !!rcopiaRes;
  const { firstName, lastName, userCredentials, siteTimezone } = currentUser;
  const borderNote = savedNote || {
    personname: `${firstName} ${lastName}`,
    credentials: userCredentials,
    noteddatetime: Date.now(),
    visitdatetime: appVisit?.effectivedatetime,
    sitetimezone: siteTimezone,
  };
  const noteId1 = smallWidget ? 'small-notes-text-area1' : 'notes-text-area1';
  const noteId2 = smallWidget ? 'small-notes-text-area2' : 'notes-text-area2';

  useEffect(() => {
    // if order has been completed then focus on the writing note
    if (orderCreated && document.getElementById(noteId1)) {
      // eslint-disable-next-line no-unused-expressions
      document.getElementById(noteId1)?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderCreated, !!document.getElementById(noteId1)]);

  // when deleting note manually
  useEffect(() => {
    if (noteStarted) {
      if (noteInputText === emptyText) {
        dispatch({
          type: SET_NOTE_STARTED,
          payload: false,
        });
      }
    }
  }, [noteStarted, noteInputText]);

  // when canceling a note or saving a note
  useEffect(() => {
    if (emptyNote) {
      setNoteInputText(emptyText);
    }
  }, [emptyNote]);

  // when saving the note, get the text
  useEffect(() => {
    if (saveNoteText) {
      dispatchOrders({
        type: SET_NOTE_TEXT,
        payload: noteInputText,
      });
    }
  }, [saveNoteText]);

  const handleNoteChange = (event: any) => {
    const { value: nextValue } = event.target;
    setNoteInputText(nextValue);
    // indicate the note started
    !noteStarted &&
      dispatch({
        type: SET_NOTE_STARTED,
        payload: true,
      });
  };

  const handleChange = (event: any) => {
    const { value: nextValue } = event.target;

    if (attemptedVisitNote) {
      if (
        noteInputText.includes(attemptedVisitNote) &&
        nextValue.length >= attemptedVisitNote.length
      ) {
        handleNoteChange(event);
      }
    } else {
      handleNoteChange(event);
    }
  };

  return smallWidget ? (
    <></>
  ) : (
    <>
      <TextAreaWrapper id="notes-text-area-wrapper">
        <Backdrop open={!!admitErrorCount} style={{ zIndex: 1000 }} />
        <TextAreaGroup id="text-area-group">
          <BorderGroup id="border-group">
            <TagNote note={savedNote || null} />
            <BorderNote note={borderNote as any} inProgress />
          </BorderGroup>

          {savedNote && orderType ? (
            <>
              <OrderStatement />
              {isRcopiaOpen && <LinearProgress />}
            </>
          ) : (
            <>
              <TextField
                id={noteId2}
                name="editableNote"
                placeholder={defaults.textArea}
                minRows={4}
                maxRows={90}
                onChange={handleChange}
                value={noteInputText}
                variant="outlined"
                multiline
                InputProps={{
                  classes: {
                    input: classes.inputFieldHeight,
                    root: classes.inputField,
                  },
                }}
                classes={{
                  root: classes.inputFieldBorder,
                }}
              />
              {noteInputText !== emptyText && <SubmitNote fixed />}
            </>
          )}
        </TextAreaGroup>
      </TextAreaWrapper>
      <DischargeMedsModal />
      <RcopiaModal />
    </>
  );
};

export default NoteInput;
